// store/slices/displayGroupingSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { GroupDisplayResult } from '../interface/bo-interface/group-display.interface';

interface DisplayGroupingState {
  data: GroupDisplayResult[];
}

const initialState: DisplayGroupingState = {
  data: [],
};

export const POSDisplayGroupingSlice = createSlice({
  name: 'displayGrouping',
  initialState,
  reducers: {
    setDisplayGroupings(state, action: PayloadAction<GroupDisplayResult[]>) {
      state.data = action.payload;
    },

    clearDisplayGroupings(state) {
      state.data = [];
    },
  },
});

export const { setDisplayGroupings, clearDisplayGroupings } =
  POSDisplayGroupingSlice.actions;

export default POSDisplayGroupingSlice.reducer;
